import { User } from "../lib/cnb/api/public";

export type PaymentHistoryDelivery = "window" | "email";

export interface PaymentHistoryApi {
  openPaymentHistory: () => Promise<unknown>;
  requestPaymentHistoryByEmail: () => Promise<unknown>;
}

export const isProAccount = (user: User | null | undefined): boolean =>
  user?.roles?.some((role) => role.startsWith("ROLE_PRO")) ?? false;

export const openPaymentHistoryFor = async (
  user: User | null | undefined,
  api: PaymentHistoryApi,
): Promise<PaymentHistoryDelivery> => {
  if (isProAccount(user)) {
    await api.requestPaymentHistoryByEmail();
    return "email";
  }
  await api.openPaymentHistory();
  return "window";
};

export const paymentHistoryErrorMessage = (error: unknown): string => {
  const detail = error instanceof Error ? error.message : "";
  return detail
    ? `Can't connect to Stripe for payment history: ${detail} 😞`
    : "Can't connect to Stripe for payment history 😞";
};

export const paymentHistoryEmailSentMessage =
  "We've emailed you a secure link to your payment history and invoices. Please check your inbox.";

export type PaymentHistoryNotice = {
  kind: "success" | "error";
  message: string;
};

export const runPaymentHistoryFlow = async (
  open: () => Promise<PaymentHistoryDelivery>,
  notify: (notice: PaymentHistoryNotice) => void,
): Promise<void> => {
  try {
    const deliveredVia = await open();
    if (deliveredVia === "email") {
      notify({ kind: "success", message: paymentHistoryEmailSentMessage });
    }
  } catch (e) {
    notify({ kind: "error", message: paymentHistoryErrorMessage(e) });
  }
};
